import { render, staticRenderFns } from "./change-marker.component.vue?vue&type=template&id=85192ba0"
import script from "./change-marker.component.ts?vue&type=script&lang=ts&external"
export * from "./change-marker.component.ts?vue&type=script&lang=ts&external"
import style0 from "./change-marker.style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports